<template>
  <div class="preheat-page" :class="skinbgc">
    <div @click="confirmStay">
      <div
        class="msg-box disFlex Flex-center"
        v-if="showNotice && !seckillSignupFlag && notice && notice.description"
      >
        <van-notice-bar
          left-icon="volume-o"
          background="rgba(0, 46, 116, 0.6)"
          color="#fff"
          :class="lightbgc"
          scrollable
          :text="notice.description"
        ></van-notice-bar>
        <div class="sub-box disFlex fc" :class="lightbgc">
          <div class="sub-live" @click.stop.prevent="subLive" v-if="diffTime">
            {{ appointStatus ? "预约成功" : "预约直播" }}
          </div>
          <div style="color: #fff" @click.stop.prevent="showNotice = false">
            X
          </div>
        </div>
      </div>
      <div
        class="invite-tip f fc fvc"
        v-if="inviteUser && !actSignupFlag && !seckillSignupFlag"
        :class="skinbgc"
      >
        <img
          :src="inviteUserAvatar"
          class="invite-avatar"
          v-if="inviteUserAvatar"
        />
        <div>{{ inviteUser }}邀请了你</div>
      </div>
      <!-- 头部 -->
      <div class="main-pic" v-if="!loadingFlag">
        <div class="img-container">
          <img
            :src="
              poster
                ? poster + '?v=4'
                : 'https://j.weizan.cn/youxiang/default-head-bg.png'
            "
            class="main-img"
            style="width: 100%; height: 100%"
          />
        </div>

        <div class="f fvc v">
          <div
            v-if="liveStartTime && !diffTime && liveUrl"
            class="enter-live-btn"
            @click.stop.prevent="watchLive"
          >
            进入直播
          </div>
          <div
            class="signup-btn"
            :class="customstyle1"
            @click.stop.prevent="openActSignup"
            v-else
          >
            {{  isAfterAct? "活动已结束" : enrollStatus === "enrolled" ? "已报名" : "立即报名" }}
          </div>
        </div>

        <transition name="join-tip">
          <div
            class="join-tip"
            v-if="currentEnrollUserName && currentEnrollFlag"
            :class="fontcolor"
          >
            {{ currentEnrollUserName }} 参加了活动
          </div>
        </transition>

        <div class="left-ads f v" v-if="leftADs">
          <div
            class="ad-item"
            :class="customstyle2"
            v-for="(item, index) in leftADs"
            :key="item.id"
            @click.stop.prevent="showImg(item)"
          >
            {{ (item && item.name) || `广告位${index + 1}` }}
          </div>
        </div>
      </div>

      <div
        class="act-data-box f fc"
        v-if="(liveStartTime && diffTime) || showNumStatus"
        :class="customstyle3"
      >
        <div
          class="act-data disFlex Flex-center Flex-around"
          v-if="showNumStatus"
        >
          <div class="data-item disFlex vertical fvc fv">
            <div class="num">{{ enrollNum }}</div>
            <div class="tag">报名数</div>
          </div>
          <div class="data-item disFlex vertical fvc fv">
            <div class="num">{{ shareNum }}</div>
            <div class="tag">分享数</div>
          </div>
          <div class="data-item disFlex vertical fvc fv">
            <div class="num">{{ viewNum }}</div>
            <div class="tag">浏览数</div>
          </div>
        </div>

        <div
          class="right"
          v-if="showNumStatus && liveStartTime && diffTime"
          :class="customstyle4"
        >
          <div class="timeout-box disFlex Flex-center frd">
            <div class="timeout-detail f v fvc frd" :class="customstyle5">
              <div>距直播开始：</div>
              <div>
                {{ diffTime.days }}天 {{ diffTime.hours }}时
                {{ diffTime.minutes }}分 {{ diffTime.seconds }}秒
              </div>
              <div
                class="sub-btn"
                @click.stop.prevent="subLive"
                :class="customstyle6"
              >
                {{ appointStatus ? "预约成功" : "预约直播" }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="only-timeout"
          v-else-if="!showNumStatus && liveStartTime && diffTime"
        >
          <div class="timeout-box disFlex Flex-center frd">
            <div class="timeout-detail f fvc frd">
              <div>距直播开始：</div>
              <div>
                {{ diffTime.days }}天 {{ diffTime.hours }}时
                {{ diffTime.minutes }}分 {{ diffTime.seconds }}秒
              </div>
              <div
                class="sub-btn"
                @click.stop.prevent="subLive"
                :class="fontcolor"
              >
                {{ appointStatus ? "预约成功" : "预约直播" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="index-info-box" v-if="pageSetData">
        <div
          class="index-item"
          v-for="(item, index) in pageSetData"
          :key="index"
        >
          <!-- 图片 -->
          <div class="act-pic f fc Flex-wrap" v-if="item.type === 0">
            <img
              class="pic-item"
              v-for="(pic, idx) in item.content"
              :class="{ 'half-item': pic.style === false }"
              :key="idx"
              :src="pic.src"
              @click.stop.prevent="jumpUrl(pic.value)"
            />
          </div>
          <!-- 视频 -->
          <div class="video-area" v-if="item.type === 1">
            <yx-video
              :src="item.src"
              :poster="item.cover"
              :index="index"
            ></yx-video>
          </div>
          <!-- 卡券 -->
          <div v-if="item.type === 2 && cardInfo">
            <card-coupon
              @viewCardDetail="viewCardDetail"
              :cardInfo="cardInfo"
              :couponList="couponList"
              :buy="cardBuy"
              :showType="item.showType"
              :color="styleColor"
            ></card-coupon>
          </div>
          <!-- 秒杀 -->
          <div
            class="seckill-area"
            v-if="item.type === 3 && seckillActInfo"
            id="seckill-area-box"
          >
            <div
              class="area-header disFlex fc fvc vertical"
              v-if="seckillActInfo.shareTitle || seckillDiffTime"
              :class="boxshadow"
            >
              <!-- <div class="head-title">{{seckillActInfo.shareTitle}}</div> -->
              <img
                src="https://j.weizan.cn/youxiang/seckill-title2.png"
                class="secill-title-bg"
                v-if="styleColor!='yellow'"
              />
              <div class="timeout-detail f fc" v-if="seckillDiffTime">
                <div :class="customstyle9">
                  {{
                    seckillActInfo.status === "active"
                      ? "距活动结束"
                      : seckillActInfo.status === "finish"
                      ? "活动已结束"
                      : seckillActInfo.status === "no_start"
                      ? "距活动开始"
                      : ""
                  }}
                </div>
                <div v-if="seckillActInfo.status !== 'finish'">
                  <span class="time-unit" :class="customstyle10">{{
                    seckillDiffTime.days
                  }}</span>
                  <span :class="customstyle9">天</span>
                  <span class="time-unit" :class="customstyle10">{{
                    seckillDiffTime.hours
                  }}</span
                  ><span :class="customstyle9">时</span>
                  <span class="time-unit" :class="customstyle10">{{
                    seckillDiffTime.minutes
                  }}</span
                  ><span :class="customstyle9">分</span>
                  <span class="time-unit" :class="customstyle10">{{
                    seckillDiffTime.seconds
                  }}</span
                  ><span :class="customstyle9">秒</span>
                </div>
              </div>
            </div>
            <van-list
              v-model="loadingSec"
              :finished="finishedSwc"
              :offset="1"
              :immediate-check="false"
              @load="onLoad"
            >
              <div class="area-body">
                <div
                  class="seckill-box"
                  v-for="item in seckillList"
                  :key="item.id"
                >
                  <div class="seckill-item" v-if="!item.isAdv">
                    <img :src="SecBgImg" class="act-img" />
                    <div class="seckill-detail disFlex Flex-center">
                      <img
                        :src="
                          item.cover ||
                          'https://j.weizan.cn/city/app/default-pic500.png'
                        "
                        class="item-img"
                        @click.stop.prevent="viewImg(item.cover)"
                      />
                      <div
                        class="item-right f v fbt"
                        @click.stop.prevent="viewSeckillItemInfo(item)"
                      >
                        <div class="item-title clamp1" :class="customstyle7">
                          {{ item.name }}
                        </div>
                        <div class="item-data disFlex fc Flex-between">
                          <div class="data-left">
                            <div class="f">
                              <div class="item-num clamp1" :class="skinbgc">
                                已抢{{ item.sales }}{{ item.pieceUnit }}，仅剩{{
                                  item.stock
                                }}{{ item.pieceUnit }}
                              </div>
                            </div>
                            <div class="origin-price" :class="customstyle7">
                              划线价：{{ item.salePrice }}元/{{
                                item.measureUnit
                              }}
                            </div>
                          </div>
                          <div class="data-right f fc" :class="customstyle7">
                            <span style="font-size: 12px">￥</span>
                            {{ item.seckillPrice }}
                          </div>
                        </div>
                        <div class="item-info disFlex fc Flex-between">
                          <div class="item-card">
                            <img :src="item.brandLogo" class="item-brand" />
                          </div>
                          <div
                            class="item-btn"
                            :class="customstyle8"
                            @click.stop.prevent="confirmNow(item)"
                            v-if="
                              item.status === 'no_start' ||
                              (item.status === 'help_success' &&
                                item.assist === 0)
                            "
                          >
                            立即秒杀
                          </div>
                          <div
                            class="item-btn"
                            :class="customstyle8"
                            @click.stop.prevent="viewSeckillDetail(item)"
                            v-else-if="
                              item.status === 'sharing' ||
                              (item.status === 'help_success' &&
                                item.assist > 0)
                            "
                          >
                            进度{{ item.helpCount }}/{{ item.assist }}
                          </div>
                          <div
                            class="item-btn"
                            :class="customstyle8"
                            @click.stop.prevent="viewSeckillDetail(item)"
                            v-else
                          >
                            {{
                              item.status === "success"
                                ? "去核销"
                                : item.status === "applied"
                                ? "秒杀成功"
                                : item.status === "sellout"
                                ? "已抢完"
                                : item.status === "finish"
                                ? "已结束"
                                : ""
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ad-item">
                    <img
                      :src="item.logo"
                      class="ad-img"
                      v-if="item.isAdv"
                      @click.stop.prevent="jumpUrl(item.url)"
                    />
                  </div>
                </div>
              </div>
            </van-list>
          </div>

          <!-- 集赞 -->
          <div v-if="item.type === 6 && likeInfo">
            <collect-like
              :likeInfo="likeInfo"
              :stylecolor="styleColor"
              @joinLikeAct="joinLikeAct"
            ></collect-like>
          </div>
          <!-- 底部信息 -->
          <div v-if="item.type === 7">
            <bottom-info
              :wxMqQrcode="wxMqQrcode"
              :stylecolor="styleColor"
            ></bottom-info>
          </div>
        </div>
      </div>
    </div>
    <div v-if="actSignupFlag">
      <act-signup
        @closeSignup="confirmStay"
        @signupSuccess="actSignupSuccess"
        :enrollNum="enrollNum"
        :callSrouce="callSrouce"
      ></act-signup>
    </div>
    <div v-if="seckillSignupFlag">
      <seckill-signup
        @closeSignup="closeSeckillSignup"
        @signupSuccess="seckillSignupSuccess"
        :enrollNum="enrollNum"
        :status="seckillActInfo.status"
        :startTime="seckillActInfo.startTime"
        :endTime="seckillActInfo.endTime"
        :productNum="seckillActInfo.productNum"
        :item="seclectedSeckill"
      ></seckill-signup>
    </div>
    <div class="totop" @click="totop">
      <img src="./../../assets/totop2.png" alt="">
    </div>
    <van-dialog
      v-model="stayFlag"
      show-cancel-button
      confirmButtonText="继续报名"
      cancelButtonText="放弃优惠"
      @confirm="stayFlag = false"
      @cancel="closeActSignup"
    >
      <template>
        <div class="f v fvc" style="padding: 20px 0">
          <img
            src="https://j.weizan.cn/youxiang/cry-face.png"
            class="cry-face"
          />

          <div
            style="
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(0, 48, 120, 1);
              margin-bottom: 10px;
            "
          >
            真心不想让您错过这次优惠
          </div>

          <div
            style="
              text-align: center;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(116, 116, 116, 1);
            "
          >
            这次优惠让利空前
          </div>
        </div>
      </template>
    </van-dialog>
    <van-dialog
      v-model="appointFlag"
      show-cancel-button
      confirmButtonText="预约直播"
      cancelButtonText="取消"
      confirmButtonColor="red"
      @confirm="subLive"
      @cancel="appointFlag = false"
    >
      <template>
        <div class="f v fvc" style="padding: 20px 0">
          <img
            src="https://static2.weizan.cn/zhibo/livecontent/homelive/img/icon-lives-3.png"
            class="cry-face"
          />
          <div
            style="
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(0, 48, 120, 1);
              margin-bottom: 10px;
            " 
          >
            本场活动直播即将开始
          </div>

          <div
            style="
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(116, 116, 116, 1);
            "
          >
            预约直播不错过优惠活动
          </div>
        </div>
      </template>
    </van-dialog>
    <van-dialog
      v-model="livingFlag"
      show-cancel-button
      confirmButtonText="立即进入"
      cancelButtonText="稍后进入"
      confirmButtonColor="red"
      @confirm="watchLive"
      @cancel="livingFlag = false"
    >
      <template>
        <div class="f v fvc" style="padding: 20px 0">
          <img
            src="https://static2.weizan.cn/zhibo/livecontent/homelive/img/icon-lives-3.png"
            class="cry-face"
          />
          <div
            style="
              text-align: center;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: black;
              margin-bottom: 10px;
            " 
          >
            本场活动直播即将开始
          </div>

          <div
            style="
              text-align: center;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(116, 116, 116, 1);
            "
          >
            本场直播已经开始啦！
          </div>
          <div
            style="
              text-align: center;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(116, 116, 116, 1);
            "
          >
            优惠多多，福利多多，马上开抢吧
          </div>
        </div>
      </template>
    </van-dialog>

    <van-dialog
      v-model="popADFlag"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <template>
        <div
          class="f v fvc"
          style="padding: 20px 0"
          @click.stop.prevent="jumpUrl(popAD.url)"
          v-if="popAD"
        >
          <img :src="popAD.logo" style="width: 80vw; height: 80vw" />
        </div>
      </template>
    </van-dialog>
    <van-dialog
      v-model="leftAdPicFlag"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <template>
        <div
          class="f v fvc"
          style="padding: 20px 0"
          @click.stop.prevent="jumpUrl(currentLeftAdUrl)"
          v-if="leftAdPicFlag"
        >
          <img :src="currentLeftAdPic" style="width: 80vw; height: 80vw" />
        </div>
      </template>
    </van-dialog>
    <van-dialog
      v-model="seckillInfoFlag"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <template>
        <div
          class="f v info-dialog"
          v-if="seckillInfoFlag && currentSeckillItem"
        >
          <div class="info-head f fc">
            <img :src="currentSeckillItem.cover" class="info-img" />
            <div class="f v fbt info-detail">
              <div class="name">{{ currentSeckillItem.name }}</div>
              <div class="f fc">
                <div class="sale-price">
                  ￥{{ currentSeckillItem.seckillPrice }}
                </div>
                <div class="line-price">
                  ￥{{ currentSeckillItem.salePrice }}
                </div>
              </div>
              <div class="stock">库存：{{ currentSeckillItem.stock }}</div>
            </div>
          </div>
          <div class="info-body">
            <div class="info-item">
              品牌：{{ currentSeckillItem.brandName }}
            </div>
            <div class="info-item">规格：{{ currentSeckillItem.specs }}</div>
            <!-- <div class="f fc info-item" v-if="currentSeckillItem.description">
              <div>描述：</div>
              <div v-html="currentSeckillItem.description" class="info-content html-content"></div>
            </div>-->
          </div>
        </div>
      </template>
    </van-dialog>
    <div class="activity" v-if="activityRule.showRule" @click="handleActivity">
      <div class="act-width" :class="customstyle2">{{activityRule.buttonContent || '活动规则'}} </div>
    </div>
    <van-dialog
        class="activity-dialog"
        v-model="showActivityRule"
        confirmButtonText="关闭"
        @confirm="showActivityRule = false"
        :close-on-click-overlay="false"
    >
      <div class="content">
        <h2>{{activityRule.buttonContent || '活动规则'}}</h2>
        <div class="ruleContent" v-html="activityRule.ruleContent"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import BottomNav from "./../../components/bottom-nav";
import ActSignup from "./../../components/act-signup";
import SeckillSignup from "./../../components/seckill-signup";
import BottomInfo from "./module/bottom-info";
import CollectLike from "./module/collect-like";
import CardCoupon from "./module/card-coupon";
import YxVideo from "./../../components/video";

import { getCountDownObjByStr } from "./../../utils/tools";
export default {
  components: {
    BottomNav,
    ActSignup,
    SeckillSignup,
    BottomInfo,
    CollectLike,
    CardCoupon,
    YxVideo,
  },
  data() {
    return {
      loadingFlag: true,
      showActivityRule: false,
      actSignupFlag: false,
      seckillSignupFlag: false,
      actName: "",
      enrollNum: 0,
      shareNum: 0,
      viewNum: 0,
      poster: "",
      currentEnrollFlag: false,
      currentEnrollUserName: "",
      enrollUserList: [],
      enrollUserIndex: 0,
      enrollUserInterval: null,
      showNotice: true,
      notice: null, //公告
      popAD: null, // 弹窗广告
      leftADs: [], //左测广告
      liveTimeInterval: null,
      diffTime: null,
      subMsgAction: this.$route.query.action || "",
      appointStatus: false, // 预约状态
      stayFlag: false,
      appointFlag: false,
      livingFlag: false,
      popADFlag: false, // 弹窗广告标志
      leftAdPicFlag: false, // 左侧广告标志
      currentLeftAdPic: "",
      currentLeftAdUrl: "",
      currentSeckillPage: 1,
      seckillActInfo: null,
      seckillList: [],
      seckillTotal: 0, //秒杀列表分页加载渲染当前数量
      seckillDiffTime: null,
      pageSetData: [],
      cardInfo: null,
      couponList: [],
      likeInfo: null,
      wxMqQrcode: "",
      inviteUser: "", // 邀请客户
      inviteUserAvatar: "",
      sceneFrom: "", // 来源场景
      seclectedSeckill: null, // 当前选中秒杀
      liveStartTime: new Date().getTime(),
      liveUrl: "",
      cardBuy: false,
      callSrouce: "",
      showNumStatus: false,
      seckillInfoFlag: false,
      currentSeckillItem: null,
      logSent: false,
      // logSentTimeout: null,
      isenrolled: true,
      enrollStatus: localStorage.getItem("setEnrollStatus"),
      // 分页加载数据
      loadingSec: false,
      finishedSwc: false,
      styleColor: true, //页面风格默认红色
      redSecBg:
        "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/image/common/style/red/seckill.png", //页面风格默认红色
      blueSecBg: "https://j.weizan.cn/youxiang/seckill-bg.png", //蓝色秒杀bg
      purpleSecBg:
        "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/image/common/style/purple/seckillbg-purple.png", //紫色秒杀bg
      greenSecBgn:
        "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/image/common/style/green/seckillbg-green.png", //绿色秒杀bg
      yellowSecBg:
        "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/image/common/style/yellow/seckillbg-yellow.png", //黄色秒杀bg
      SecBgImg: "https://j.weizan.cn/youxiang/seckill-bg.png",
      skinbgc: {
        "had-tip": this.inviteUser,
      },
      lightbgc: {},
      fontcolor: {},
      boxshadow: {},
      linearOne: {},
      customstyle1: {},
      customstyle2: {},
      customstyle3: {},
      customstyle4: {},
      customstyle5: {},
      customstyle6: {},
      customstyle7: {},
      customstyle8: {},
      customstyle9: {},
      customstyle10: {},
      customstyle11: {},
      customstyle12: {},
      green: {},
      yellow: {},
      activityRule: {},
      // openShareTimeline:false,//2021.7.22朋友圈开关
      isAppoint:true,
      isLiving:false,
      isAfterAct:false,
    };
  },
  computed: {
    // ...mapState(["canJoinAct", "enrollStatus"]),
    liveStatus: function () {
      let now = new Date().getTime();
      if (new Date(this.liveStartTime).getTime() > now) {
        return 0; //未开始
      } else {
        return 1; //已开始
      }
    },
  },
  created() {
    // 首页先获取是否开启朋友圈分享，再调用微信注册
    // this.getShareSet();
    this.isenrolled = this.$route.query.isenrolled;
    console.log(this.$route.query.share_user_name);
    // decodeURIComponent(`${this.$route.query.share_user_name}`)
    this.inviteUser = this.$route.query.share_user_name
      ? this.$route.query.share_user_name
      : "";
    this.inviteUserAvatar = this.$route.query.share_user_avatar
      ? decodeURIComponent(this.$route.query.share_user_avatar)
      : "";
    this.sceneFrom = this.$route.query.scene || "";
    this.$store.commit("setLoading", true);
    this.getActInfo();
    this.getHeadData();
    this.getAcivityRule();
    this.getTopicDetail();
    // if (this.$route.query.tips) {
    //   this.$toast(this.$route.query.tips);
    // }
  },
  mounted() {
    // this.logSentTimeout = setTimeout(() => {
    //   console.log(this.logSent);
    //   if (!this.logSent) {
    //     this.$txLogs({
    //       scene: this.sceneFrom,
    //     });
    //   }
    // }, 3000);
  },
  destroyed() {
    clearInterval(this.enrollUserInterval);
    clearInterval(this.liveTimeInterval);
    clearTimeout(this.enrollTimeout);
    clearInterval(this.seckillTimeInterval);
    // clearTimeout(this.logSentTimeout);
  },
  methods: {
    async getAppointmentStatus(){
      let res = await this.$http.post(`/v1/home/check_appointment_status`);
      console.log(res);
      if (res.code == 0) {
        this.isAppoint = res.data;
      }else{
        this.isAppoint = true;
      }
      if(this.subMsgAction === "confirm" || this.appointStatus){
        this.isAppoint = true;
      }
    },
    getShareSet(openShareTimeline){
      this.$initWXSDK(
        {
          openShare: true,
          openShareTimeline: openShareTimeline,
        },
        () => {
          this.$utils.getLocation().then(() => {
            this.$txLogs({
              scene: this.sceneFrom,
            });
            this.logSent = true;
          });
        }
      );
    },
    handleActivity () {
      this.showActivityRule = true
    },
    async getAcivityRule () {
      let actId = this.$route.query.act_id || localStorage.getItem("act_id")
      let res = await this.$http.post(`/v1/home/get_rule?actId=${actId}`);
      if (res.code === 0) {
        this.activityRule = res.data
      }
    },
    async getTopicDetail () {
      let res = await this.$http.post(`/v1/home/get_topic_status`);
      console.log(res);
      // -1==未开始 1==开始 0==结束 2==暂停
      if (res.code === 0 && (res.data==1||res.data==2)) {
        this.livingFlag = true;
      }
    },
    viewSeckillItemInfo(item) {
      this.currentSeckillItem = item;
      this.seckillInfoFlag = true;
    },
    getActInfo() {
      this.$http.post("/v1/home/activity").then((res) => {
        console.log('res,', res)
        if (res.code === 0) {
          if(new Date(res.data.actEndTime.trim().replace(/-/g, "/")) < new Date()){
            this.isAfterAct = true;
          }
          this.$store.commit("setLoading", false);
          this.wxMqQrcode = res.data.wxMqQrcode;
          // 首页先获取是否开启朋友圈分享，再调用微信注册
          console.log(res.data.shareMomentFlag,"res.data.shareMomentFlag");
          var openShareTimeline = res.data.shareMomentFlag=="true"?true:false;
          console.log(openShareTimeline,"this.openShareTimeline");
          this.getShareSet(openShareTimeline);
          // this.styleColor = res.data.style == "red" ? true : false;
          this.styleColor = res.data.style;
          if (this.styleColor == "red") {
            this.skinbgc.red_bgc = true;
            this.lightbgc.red_bgc_light = true;
            this.fontcolor.red_c = true;
            this.boxshadow.red_boxs = true;
            // 红色风格特化
            this.customstyle1.red_c = true; //首页报名按钮样式
            this.customstyle2.red_bgc = true; //左侧广告位样式
            this.customstyle3.red_bgc = true; //三个数据的背景色样式
            // this.customstyle4.red_bgc = true;//直播倒计时背景颜色(红色不用改)
            this.customstyle5.red_c = true; //直播倒计时文字颜色
            this.customstyle6.red_bgc = true; //预约直播按钮样式
            this.customstyle7.white_c = true; //秒杀商品文字颜色
            this.customstyle8.red_c = true; //立即秒杀按钮样式
            // this.customstyle9.red_c = true;//秒杀倒计时固定文字样式
            this.customstyle10.red_c = true; //秒杀倒计时时间样式
          } else if (this.styleColor == "purple") {
            this.skinbgc.purple_bgc = true;
            this.lightbgc.purple_linear = true;
            this.fontcolor.purple_c = true;
            this.boxshadow.purple_boxs = true;
            // 紫色风格特化
            this.customstyle1.purple1 = true;
            this.customstyle2.purple2 = true;
            this.customstyle3.purple3 = true;
            this.customstyle4.purple4 = true;
            this.customstyle5.white_c = true;
            this.customstyle6.purple6 = true;
            this.customstyle7.purple_c = true;
            this.customstyle8.purple8 = true;
            this.customstyle9.white_c = true;
            this.customstyle10.purple10 = true;
          } else if (this.styleColor == "green") {
            this.skinbgc.green_bgc = true;
            this.lightbgc.green_linear = true;
            this.fontcolor.green_c = true;
            this.boxshadow.green_boxs = true;
            // 绿色风格特化
            this.customstyle1.green1 = true;
            this.customstyle2.green_bgc = true;
            this.customstyle3.green3 = true;
            this.customstyle4.green4 = true;
            this.customstyle5.white_c = true;
            this.customstyle6.green_bgc = true;
            this.customstyle7.white_c = true;
            this.customstyle8.green8 = true;
            this.customstyle9.white_c = true;
            this.customstyle10.green10 = true;
          } else if (this.styleColor == "yellow") {
            this.skinbgc.yellow_bgc = true;
            this.lightbgc.yellow_linear = true;
            this.fontcolor.yellow_c = true;
            this.boxshadow.yellow_boxs = true;
            // 黄色风格特化
            this.customstyle1.yellow1 = true;
            this.customstyle2.yellow2 = true;
            this.customstyle3.yellow3 = true;
            this.customstyle4.yellow4 = true;
            this.customstyle5.white_c = true;
            this.customstyle6.yellow6 = true;
            this.customstyle7.white_c = true;
            this.customstyle8.yellow8 = true;
            this.customstyle9.black_c = true;
            this.customstyle10.yellow10 = true;
          }
          switch (this.styleColor) {
            case "red":
              this.SecBgImg = this.redSecBg;
              break;
            case "blue":
              this.SecBgImg = this.blueSecBg;
              break;
            case "purple":
              this.SecBgImg = this.purpleSecBg;
              break;
            case "green":
              this.SecBgImg = this.greenSecBgn;
              break;
            case "yellow":
              this.SecBgImg = this.yellowSecBg;
              break;
            default:
              this.SecBgImg = this.blueSecBg;
              break;
          }
        }
      });
      this.$http.post("/v1/home/page_set").then((res) => {
        if (res.code === 0) {
          this.pageSetData = res.data.pageSetData
            ? JSON.parse(res.data.pageSetData)
            : [];
          this.pageSetData.forEach((i) => {
            if (i.type === 3) {
              this.getSeckillList();
            } else if (i.type === 2) {
              this.getCardInfo();
            } else if (i.type === 6) {
              this.getLikeInfo();
            }
          });
        }
      });
    },
    joinLikeAct() {
      if (this.likeInfo.status === "sharing") {
        let tmp = localStorage.getItem("likedetailPath") || "/likedetailbase";
        return this.$router.push({
          path: tmp,
          query: {
            self: true,
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
      if (this.likeInfo.status === "finish") {
        return false;
      }
      if (this.likeInfo.realStock === 0) {
        return false;
      }
      this.$txLogs({
        bpm: "3.collect_likes_enrollment",
      });
      this.$utils.checkEnroll().then(() => {
        if (this.enrollStatus !== "enrolled" && this.likeInfo.enrollmentFlag) {
          this.$toast("请先报名");
          this.callSrouce = "collect_like";
          this.actSignupFlag = true;
          return false;
        }
        this.$http.post("/v1/home/collect_like/start").then((res) => {
          if (res.code === 0) {
            let tmp = localStorage.getItem("likedetailPath") || "/likedetailbase";
            this.$router.push({
              path: tmp,
              query: {
                self: true,
                act_id:
                  this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          }
        });
      });
    },
    async getLikeInfo() {
      let info = await this.$http.post("/v1/home/collect_like/", {
        self: true,
        showHelp: false,
      });
      this.likeInfo = info.data;
    },
    async getCardInfo() {
      let info = await this.$http.post("/v1/seckill/card/list", {});
      this.cardInfo = info.data.card;
      this.couponList = info.data.couponList;
      this.cardBuy = info.data.buy;
    },
    async getSeckillList() {
      let list = await this.$http.post("/v1/seckill/product/static/list", {
        page: this.currentSeckillPage,
        size: 10,
      });

      this.seckillActInfo = list?.data?.seckillAct;
      // 暂时获取接口信息，循环插入用户秒杀信息

      var seckillList = list?.data?.products?.list;
      this.seckillTotal = list?.data?.products?.total;

      this.calcSeckillTime(this.seckillActInfo);

      // // 针对本地用户获取对应的秒杀信息
      let list2 = await this.$http.post("/v1/seckill/product/user/list");
      // 如果秒杀信息为空，则不遍历，遍历后赋值
      var userlist = list2?.data?.list || [];
      console.log(userlist);
      if (userlist.length != 0) {
        seckillList.forEach((item, index) => {
          userlist.forEach((item2, index2) => {
            if (item.id == item2.productId) {
              item.status = item2.status;
              item.helpCount = item2.helpCount;
              item.assist = item2.assist;
            }
          });
        });
      }
      // 赋值渲染（拼接）
      if (this.currentSeckillPage === 1) {
        this.seckillList = seckillList || [];
      } else {
        this.seckillList = this.seckillList.concat(seckillList);
      }
      // this.seckillList = seckillList;

      this.loadingSec = false; //关闭onload判断

      if (this.$route.query.scrollToSeckill) {
        setTimeout(() => {
          document.getElementById("seckill-area-box").scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 800);
      }
    },
    // 加载更多充值记录
    onLoad() {
      console.log(233);
      // 获取当前的总条数，当前页数。
      // 如果条数除以10向上取整，大于当前页数，则执行一次加载
      if (Math.ceil(this.seckillTotal / 10) > this.currentSeckillPage) {
        this.currentSeckillPage = this.currentSeckillPage + 1;
        this.getSeckillList();
      } else {
        // if (this.currentSeckillPage != 1) {
        //   this.finishedSwc = true;
        // }

        this.finishedSwc = true;
      }

      // this.loadingSec = false;
    },
    async getHeadData() {
      let res = await this.$http.post("/v1/home/head");
      if (res.code === 0) {
        localStorage.setItem("actName", res.data.actName);
        document.title = res.data.actName;
        this.actName = res.data.actName;
        this.shareNum = res.data.shareNum;
        this.enrollNum = res.data.enrollNum;
        this.viewNum = res.data.viewNum;
        this.poster = res.data.poster;
        this.showNumStatus = res.data.showNumStatus;
        this.enrollUserList = res.data.enrollUserList;
        this.appointStatus = res.data.appointStatus;
        this.liveStartTime = res.data.liveStartTime;
        this.liveUrl = res.data.liveUrl;
        console.log(this.poster);
        // this.$store.commit(
        //   "setEnrollStatus",
        //   res.data.enrollStatus ? "enrolled" : "no_enroll"
        // );
        localStorage.setItem(
          "setEnrollStatus",
          res.data.enrollStatus ? "enrolled" : "no_enroll"
        );
        this.enrollStatus = res.data.enrollStatus ? "enrolled" : "no_enroll";
        for (let ad of res.data.advList) {
          if (ad.position === "left") {
            this.leftADs.push(ad);
          } else if (ad.position === "pop") {
            this.popAD = ad;
          } else if (ad.position === "roll") {
            this.notice = ad;
          }
        }
        this.showEnrollUserList();
        this.loadingFlag = false;
        // 如果有直播地址和直播开始时间
        if(res.data.liveStartTime && res.data.liveUrl){
          this.calcLiveTime(res.data.liveStartTime);
          if(new Date(res.data.liveStartTime.trim().replace(/-/g, "/")) > new Date()){
            this.getAppointmentStatus();
          }
        }
        if (this.subMsgAction == "confirm") {
          this.appointLive();

          this.$txLogs({
            bpm: "3.appointment_submit",
          });
        }
      }
    },
    viewCardDetail() {
      if(!this.isAppoint){
        this.appointFlag = true;
        return;
      }
      this.$router.push({
        path: "/couponDetail",
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    viewImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    viewSeckillDetail(item) {
      this.$router.push({
        path: this.$utils.getSeckillDetailPath(),
        query: {
          id: item.id,
          self: true,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    //
    confirmNow(item) {
      if(!this.isAppoint){
        this.appointFlag = true;
        return;
      }
      this.$txLogs({
        bpm: "3.seckill_enrollment",
      });
      // 8.31二期优化，秒杀支付转移到seckillm秒杀详情中进行，无论是否报名也跳转到
      this.seckillNow(item);

      // 检查是否已报名状态
      // this.$utils.checkEnroll().then(() => {
      // if (this.enrollStatus !== "enrolled") {
      //   this.seckillSignupFlag = true;
      //   this.seclectedSeckill = item;
      //   return false;
      // }

      // if (this.seckillActInfo.productNum === 0) {
      //   return this.seckillNow(item);
      // }

      // this.$dialog({
      //   showCancelButton: true,
      //   messageAlign: "left",
      //   message: `• 每个用户仅限购买${this.seckillActInfo.productNum}款秒杀商品，您确定要秒杀这件商品吗？\n\n• 您即将参与秒杀商品抢购，秒杀商品为限量产品，秒完即止，请随时关注页面剩余数量`,
      // })
      //   .then(() => {
      //     this.seckillNow(item);
      //   })
      //   .catch(() => {
      //     this.$txLogs({
      //       bpm: "3.seckill_cancle",
      //     });
      //   });
      // });
    },
    seckillNow(item) {
      this.$txLogs({
        bpm: "3.seckill_submit",
      });
      // 存入当前的秒杀商品item
      // this.$store.commit("setSecKillItem", item);
      localStorage.setItem("setSecKillItem", JSON.stringify(item));
      console.log(item);
      this.$router.push({
        path: this.$utils.getSeckillDetailPath(),
        query: {
          id: item.id,
          self: true,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
      // 检查购买数量（转移到秒杀详情页面）
      // this.$http
      //   .post("/v1/seckill/task/pre_start", {
      //     productId: item.id,
      //   })
      //   .then((res) => {
      //     if (res.code === 0) {
      //       this.$router.push({
      //         path: "/seckillDetail",
      //         query: { id: item.id, self: true,act_id: localStorage.getItem("act_id"), },
      //       });
      //     }
      //   });
    },
    calcSeckillTime(item) {
      let time = item.status === "no_start" ? item.startTime : item.endTime;
      this.seckillTimeInterval = setInterval(() => {
        this.seckillDiffTime = getCountDownObjByStr(time);
        !this.seckillDiffTime && clearInterval(this.seckillTimeInterval);
      }, 1000);
    },
    calcLiveTime(time) {
      this.liveTimeInterval = setInterval(() => {
        this.diffTime = getCountDownObjByStr(time);
        if(!this.diffTime){
          clearInterval(this.liveTimeInterval);
        }
      }, 1000);
    },
    watchLive() {
      if (this.liveUrl) {
        this.$txLogs({
          bpm: "3.live_view",
        });
        location.href = this.liveUrl;
      }
    },
    showEnrollUserList() {
      clearInterval(this.enrollUserInterval);
      if (this.enrollUserList.length > 0) {
        this.enrollUserInterval = setInterval(() => {
          this.currentEnrollFlag = false;
          if (this.enrollUserIndex >= this.enrollUserList.length - 1) {
            this.enrollUserIndex = 0;
          } else {
            this.enrollUserIndex++;
          }
          this.currentEnrollUserName = this.enrollUserList[
            this.enrollUserIndex
          ]?.name;
          this.enrollTimeout = setTimeout(() => {
            this.currentEnrollFlag = true;
          }, 800);
        }, 3500);
      }
    },
    jumpUrl(url) {
      url && (location.href = url);
    },
    showImg(item) {
      this.currentLeftAdPic = item.logo;
      this.currentLeftAdUrl = item.url;
      this.leftAdPicFlag = true;
    },
    actSignupSuccess(source) {
      // this.$store.commit("setEnrollStatus", "enrolled");
      localStorage.setItem("setEnrollStatus", "enrolled");
      this.enrollStatus = "enrolled";
      this.actSignupFlag = false;
      this.popAD && (this.popADFlag = true);
      if (source === "act_signup") {
        this.$txLogs({
          bpm: "3.enrollment_submit",
        });
      } else if (source === "collect_like") {
        this.$txLogs({
          bpm: "3.collect_likes_enrollment_submit",
        });
      }
    },
    seckillSignupSuccess() {
      // this.$store.commit("setEnrollStatus", "enrolled");
      localStorage.setItem("setEnrollStatus", "enrolled");
      this.enrollStatus = "enrolled";
      this.seckillSignupFlag = false;
      this.$txLogs({
        bpm: "3.seckill_enrollment",
      });
    },
    openActSignup() {
      if(this.isAfterAct){
        return this.$toast("活动已结束，感谢您的支持~");
      }
      // 如果有直播且没预约直播
      if(!this.isAppoint){
        this.appointFlag = true;
        return;
      }
      this.$utils.checkEnroll().then(() => {
        if (this.enrollStatus === "enrolled") {
          return false;
        }
        this.callSrouce = "act_signup";
        this.actSignupFlag = true;
        this.$txLogs({
          bpm: "3.enrollment",
        });
      });
    },
    //挽留窗口
    confirmStay() {
      this.actSignupFlag && (this.stayFlag = true);
    },
    closeSeckillSignup() {
      this.seckillSignupFlag = false;
      this.$txLogs({
        bpm: "3.seckill_cancle",
      });
    },
    closeActSignup() {
      this.actSignupFlag = false;
    },
    // 跳转预约授权页
    async subLive() {
      if (this.subMsgAction === "confirm" || this.appointStatus) {
        this.isAppoint = true;
        return this.$toast("您已成功预约直播~");
      }
      let config = await this.getWXConfig();
      this.$txLogs({
        bpm: "3.appointment",
      });
      const redirect_url = encodeURIComponent(location.origin);
      let scene = Math.abs(10000 - Number(localStorage.getItem("act_id")));
      let oAuthUrl =
        "https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm";
      oAuthUrl += "&appid=" + config.data.appId;
      oAuthUrl += "&scene=" + scene;
      oAuthUrl += "&redirect_url=" + redirect_url;
      oAuthUrl += "&template_id=" + config.data.msgTemplateId;
      oAuthUrl += "&reserved=test#wechat_redirect";
      location.href = oAuthUrl;
    },
    // 预约直播
    appointLive() {
      var act_id = localStorage.getItem("act_id");
      const userConfirm = localStorage.getItem(`userConfirm_${act_id}`) ||false ;
      const that = this;
      if (!userConfirm) {
        that.$http.post("/v1/home/appoint");
        that.$dialog
          .alert({
            message: `您已成功预约【${that.actName}】请留意微信订阅通知哦！`,
            confirmButtonText: "我知道了",
          })
          .then(() => {
            that.appointStatus = true;
            localStorage.setItem(`userConfirm_${act_id}`, true);
          });
      }
      this.isAppoint = true;
    },
    totop() {
      // 实现滚动效果，点击图片回到顶部方法，加计时器是为了过渡顺滑
      let top = document.documentElement.scrollTop || document.body.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 30
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },

    async getWXConfig() {
      let config1 = await this.$http.get("/v1/wechat/config/get");
      console.log(config1);
      return config1;
      // return await this.$http.get("/v1/wechat/config/get");
    },
  },
};
</script>

<style lang="less">
@import "./preheat";
.activity {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 80px;
  width: 30px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  .act-width {
    word-break: break-all;
    padding: 5px 10px 5px 8px;
    background: #003078;
    border: 1px solid #ffd18f;
    border-radius: 0 5px 5px 0;
    margin-bottom: 15px;
  }
}
.activity-dialog {
  border-radius: 0!important;
  .content {
    h2 {
      font-size: 16px;
      font-weight: 700;
      margin: 8px 0;
    }
    .ruleContent {
      text-align: left;
      max-height: 400px;
      overflow: auto;
      padding: 5px 10px 5px 5px;
    }
    img {
      width: 100%;
    }
  }
}
.totop{
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  box-shadow:  0 0 10px 0 rgba(0, 0, 0, 0.8);
  img{
    
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
}
</style>

